@let hasHeader = showHeader() || resolvedPresentation() === 'page';
@let count = titleCount();

@if (resolvedPresentation() === 'sheet') {
  <div #backdrop class="backdrop" aria-hidden="true" (click)="onClose($event)"></div>
} @else {
  <!-- A page covers its backdrop once open; the dim shows only while it slides. -->
  <div #backdrop class="backdrop" aria-hidden="true"></div>
}
<section
  #sheet
  class="surface"
  role="dialog"
  tabindex="-1"
  [cdkTrapFocus]="isActive()"
  [class.sheet]="resolvedPresentation() === 'sheet'"
  [class.sheet--compact]="resolvedPresentation() === 'sheet' && variant() === 'compact'"
  [class.page]="resolvedPresentation() === 'page'"
  [inert]="closing() || contentCovered()"
  [attr.aria-hidden]="contentCovered() ? true : null"
  [attr.aria-modal]="isActive()"
  [attr.aria-labelledby]="hasHeader ? titleId() : null"
  [attr.aria-label]="hasHeader ? null : title()"
  [awPageBackSwipe]="resolvedPresentation() === 'page' && isActive() && !closeDisabled()"
  [pageBackSwipeBackdrop]="backdrop()?.nativeElement"
  (backSwiped)="finishPageDismissal()"
  (dismissalStarted)="startPageDismissal()"
>
  @if (resolvedPresentation() === 'sheet') {
    <ng-container [ngTemplateOutlet]="handle" />
  }
  @if (hasHeader) {
    <header
      class="sheet-header"
      [class.page-header]="resolvedPresentation() === 'page' && !sheetContainer()"
      [class.sheet-header--centered]="resolvedPresentation() === 'sheet'"
      [awSheetDrag]="sheetDragTarget() ?? sheet"
      [sheetDragPanels]="sheetDragPanels()"
      [sheetDragBackdrop]="sheetDragBackdrop()"
      [sheetDragDisabled]="(resolvedPresentation() === 'page' && !sheetContainer()) || !isActive() || closeDisabled()"
      (dismissed)="onSheetDismissed($event)"
    >
      @if (resolvedPresentation() === 'page') {
        <aw-icon-button
          class="sheet-header__back"
          icon="chevron-left"
          [style]="'subtle'"
          [disabled]="closeDisabled() || closing()"
          [ariaLabel]="commonTranslations.back"
          (click)="onClose($event)"
        />
      } @else {
        <button
          type="button"
          class="close"
          [disabled]="closeDisabled() || closing()"
          [attr.aria-label]="commonTranslations.close"
          (click)="onClose($event)"
        >
          <i class="aw-2-icn" awIcon="close" aria-hidden="true"></i>
        </button>
      }
      <div class="sheet-header__title">
        @if (resolvedPresentation() === 'page') {
          <h1 [id]="titleId()">
            <span class="sheet-title">
              <span class="sheet-title-label">{{ title() }}</span>
              @if (count !== undefined) {
                <aw-counter-badge class="sheet-title-count" [count]="count" />
              }
            </span>
          </h1>
        } @else {
          <h2 [id]="titleId()">
            <span class="sheet-title">
              <span class="sheet-title-label">{{ title() }}</span>
              @if (count !== undefined) {
                <aw-counter-badge class="sheet-title-count" [count]="count" />
              }
            </span>
          </h2>
        }
      </div>
      <div class="sheet-header__actions">
        <ng-content select="[sheetActions]" />
        @if (secondaryActionIcon()) {
          <aw-icon-button
            class="sheet-header__secondary"
            [style]="'subtle'"
            [icon]="secondaryActionIcon()"
            [ariaLabel]="secondaryActionLabel()"
            (click)="onSecondaryAction()"
          />
        }
        @if (actionIcon()) {
          <aw-icon-button
            class="sheet-header__action"
            size="s"
            [style]="actionDisabled() && !actionLoading() ? 'subtle' : 'filled'"
            [icon]="actionIcon()"
            [ariaLabel]="actionLabel()"
            [disabled]="actionDisabled()"
            [loading]="actionLoading()"
            (click)="onAction()"
          />
        }
      </div>
    </header>
  }
  <div
    class="sheet-body"
    [class.sheet-body--without-header]="!hasHeader"
    [class.page-body]="resolvedPresentation() === 'page' && !sheetContainer()"
    [class.sheet-body--fixed]="bodyLayout() === 'fixed'"
    [awSheetDrag]="sheetDragTarget() ?? sheet"
    [sheetDragPanels]="sheetDragPanels()"
    [sheetDragBackdrop]="sheetDragBackdrop()"
    [sheetDragFromContent]="true"
    [sheetDragDisabled]="(resolvedPresentation() === 'page' && !sheetContainer()) || !isActive() || closeDisabled()"
    (dismissed)="onSheetDismissed($event)"
  >
    <ng-content />
  </div>
</section>
<!-- A page inside a sheet slides under a fixed handle, so the sheet keeps one handle. -->
@if (sheetContainer()) {
  <ng-container [ngTemplateOutlet]="handle" />
}

<ng-template #handle>
  <div
    class="sheet-handle"
    aria-hidden="true"
    [awSheetDrag]="sheetDragTarget() ?? sheet"
    [sheetDragPanels]="sheetDragPanels()"
    [sheetDragBackdrop]="sheetDragBackdrop()"
    [sheetDragDisabled]="!isActive() || closeDisabled()"
    (dismissed)="onSheetDismissed($event)"
  ></div>
</ng-template>
